import { call, put, select } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import {
  ContentLibraryOpenedFile,
  ContentLibraryOpenedWhiteboard,
} from 'features/content-library/types';
import {
  selectContentLibraryActiveWhiteboards,
  selectContentLibraryOpenedFile,
} from 'features/content-library/contentLibrarySlice';
import { openLastActiveWhiteboardSaga } from 'features/content-library/sagas/openLastActiveWhiteboardSaga';
import { signalingWhiteboardClosed } from 'features/layout/features/content/actions';
import {
  gridPanelVoided,
  lockedContentChanged,
  selectGridPanel,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { ContentData, GridPanelName } from 'features/layout/features/content/types';

export function* onWhiteboardClosedSaga(action: ReturnType<typeof signalingWhiteboardClosed>) {
  const lockedContent: ContentData = yield select(selectLockedContent);

  if (
    lockedContent &&
    lockedContent.type === 'whiteboard' &&
    lockedContent.id === action.payload.id
  ) {
    yield put(lockedContentChanged(null));
  }

  const openedFile: ContentLibraryOpenedFile | null = yield select(selectContentLibraryOpenedFile);
  const shouldOpenAnother = openedFile === null || openedFile.id === action.payload.id;

  const currentOpenedPanel: GridPanelName = yield select(selectGridPanel);

  const whiteboards: ContentLibraryOpenedWhiteboard[] = yield select(
    selectContentLibraryActiveWhiteboards
  );

  const filteredWhiteboards = whiteboards.filter((item) => item.id !== action.payload.id);

  if (currentOpenedPanel === 'whiteboard' && filteredWhiteboards.length > 0 && shouldOpenAnother) {
    yield call(openLastActiveWhiteboardSaga, action.payload.id);
  }

  if (filteredWhiteboards.length === 0) {
    yield put(gridPanelVoided('whiteboard'));
  }

  yield call(eventBus.sendMessage, 'whiteboardClosed', undefined, { id: action.payload.id });
}
